import { useFormWithValidation } from "@/features/forms/hooks/useFormWithValidation";
import { FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";
import FormInput from "@/features/forms/components/FormInput";
import Spinner from "@/features/forms/components/Spinner";
import { useEditSettings } from "@/features/settings/hooks/useEditSettings";

import Icon from "@/ui/icon/Icon";
import Button from "@/ui/button/Button";

import style from "./RegisterSettingsStep.module.css";
import InputPhone from "@/features/forms/components/InputPhone";

function RegisterSettingsStep({ user, nextStep }) {
	const { t } = useTranslation();
	const formMethods = useFormWithValidation({
		defaultValues: {
			username: user.username,
			first_name: user.firstName,
			last_name: user.lastName,
			phone_number: user.phoneNumber || "",
		},
	});

	const {
		handleSubmit,
		formState: { isSubmitting },
	} = formMethods;

	const { save } = useEditSettings();

	const onSubmit = async function (data) {
		await save(data);
		nextStep();
	};

	return (
		<div className={style.content}>
			<div className={style.header}>
				<Icon icon="fa-user" />
				<h2>{t("auth:register.personalInfo")}</h2>
			</div>
			<FormProvider {...formMethods}>
				<form className={style.form} onSubmit={handleSubmit(onSubmit)}>
					<FormInput
						name="username"
						autoComplete="username"
						label={t("common:fields.username.label")}
						placeholder={t("common:fields.username.placeholder")}
						required
					/>
					<FormInput
						name="first_name"
						label={t("common:fields.firstName.label")}
						placeholder={t("common:fields.firstName.placeholder")}
						required
					/>
					<FormInput
						name="last_name"
						label={t("common:fields.lastName.label")}
						placeholder={t("common:fields.lastName.placeholder")}
						required
					/>
					<InputPhone
						name="phone_number"
						label={t("common:fields.phone.label")}
						placeholder={t("common:fields.phone.placeholder")}
						required
					/>
					<div className={style.buttonHolder}>
						<Button disabled={isSubmitting} type="accent">
							{isSubmitting ? (
								<Spinner />
							) : (
								t("common:actions.continue")
							)}
						</Button>
					</div>
				</form>
			</FormProvider>
		</div>
	);
}

export default RegisterSettingsStep;
